/* BOXR concept I: header, menu, films, reveals. No dependencies. */
(function () {
  "use strict";
  var doc = document, root = doc.documentElement;
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false, addEventListener: function () {} }; };
  var reduced = mq("(prefers-reduced-motion: reduce)");
  var phone = mq("(max-width: 767px)");
  var hasIO = "IntersectionObserver" in window;

  /* ---------- header: solid once the hero (or the top of the page) is behind it ---------- */
  var hdr = doc.querySelector("[data-hdr]");
  if (hdr) {
    var over = doc.querySelector("[data-hdr-over]");
    var setSolid = function (on) { hdr.classList.toggle("is-solid", on); };
    if (hasIO) {
      /* solid as soon as the page leaves the top */
      var top = doc.createElement("div");
      top.setAttribute("aria-hidden", "true");
      top.style.cssText = "position:absolute;top:0;left:0;width:1px;height:24px;pointer-events:none";
      doc.body.prepend(top);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { setSolid(!e.isIntersecting); });
      }).observe(top);
      /* on pages with a full-screen hero, the header wordmark waits until the hero has gone */
      if (over) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { hdr.classList.toggle("is-past", !e.isIntersecting); });
        }, { rootMargin: "-" + (hdr.offsetHeight || 64) + "px 0px 0px 0px" }).observe(over);
      }
    } else { setSolid(true); hdr.classList.add("is-past"); }
  }

  /* ---------- phone menu ---------- */
  var menu = doc.getElementById("menu");
  var opener = doc.querySelector("[data-menu-open]");
  if (menu && opener && typeof menu.showModal === "function") {
    var close = function () { if (menu.open) menu.close(); };
    opener.addEventListener("click", function () {
      menu.showModal();
      opener.setAttribute("aria-expanded", "true");
      root.style.overflow = "hidden";
    });
    menu.addEventListener("close", function () {
      opener.setAttribute("aria-expanded", "false");
      root.style.overflow = "";
      opener.focus();
    });
    menu.querySelectorAll("[data-menu-close]").forEach(function (b) { b.addEventListener("click", close); });
    menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { if (a.hash && a.pathname === location.pathname) close(); }); });
    window.addEventListener("resize", function () { if (window.innerWidth >= 1024) close(); });
  } else if (opener) {
    opener.addEventListener("click", function () { location.href = opener.getAttribute("data-fallback") || "#footer"; });
  }

  /* ---------- reveals ---------- */
  var reveals = doc.querySelectorAll("[data-reveal]");
  var lateJS = window.performance && performance.now() > 2900;
  doc.documentElement.classList.add("bx-ready");
  if (lateJS) { reveals.forEach(function (el) { el.classList.add("in"); }); }
  else if (hasIO && !reduced.matches) {
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); rio.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.08 });
    reveals.forEach(function (el) { rio.observe(el); });
    requestAnimationFrame(function () { reveals.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add("in"); rio.unobserve(el); } }); });
  } else { reveals.forEach(function (el) { el.classList.add("in"); }); }

  /* ---------- horizontal rails: prev/next buttons for mouse users ---------- */
  doc.querySelectorAll("[data-rail]").forEach(function (rail) {
    var sec = rail.closest("section") || doc;
    var step = function (dir) { rail.scrollBy({ left: dir * Math.max(240, rail.clientWidth * 0.8), behavior: reduced.matches ? "auto" : "smooth" }); };
    var prev = sec.querySelector("[data-rail-prev]"), next = sec.querySelector("[data-rail-next]");
    var sync = function () {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    };
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    rail.addEventListener("scroll", function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  });

  /* ---------- films ----------
     Every <video data-src> has no src in the HTML. A clip is attached only when it comes near the viewport
     (never under reduced motion until Play is pressed), plays muted while visible, pauses offscreen and in
     hidden tabs. A pause the visitor chose sticks. Controls: [data-film-ctl] inside the .film, or
     [data-film-ctl][data-group=x] for every video with data-group=x. */
  var vids = Array.prototype.slice.call(doc.querySelectorAll("video[data-src]"));
  var lowData = (function () { var c = navigator.connection; return !!(c && (c.saveData || /2g/.test(c.effectiveType || ""))); })();
  if (!vids.length) return;
  var userPaused = {}, userStarted = {}, visible = new Map();
  var keyOf = function (v) { return v.getAttribute("data-group") || v.id || (v.id = "f" + Math.random().toString(36).slice(2, 8)); };
  var rendered = function (v) { return v.getClientRects().length > 0; };
  var srcFor = function (v) { return (phone.matches && v.getAttribute("data-src-m")) || v.getAttribute("data-src"); };
  var load = function (v) {
    if (v.getAttribute("data-loaded") === "1") return;
    v.setAttribute("data-loaded", "1");
    v.preload = "auto";
    v.src = srcFor(v);
  };
  var ctlsFor = function (k) {
    return Array.prototype.slice.call(doc.querySelectorAll('[data-film-ctl][data-group="' + k + '"]'))
      .concat(vids.filter(function (v) { return keyOf(v) === k; }).map(function (v) {
        var f = v.closest(".film"); return f && f.querySelector("[data-film-ctl]:not([data-group])");
      }).filter(Boolean));
  };
  var paint = function (k) {
    var playing = vids.some(function (v) { return keyOf(v) === k && !v.paused && !v.ended && rendered(v); });
    ctlsFor(k).forEach(function (c) {
      c.setAttribute("data-state", playing ? "playing" : "paused");
      c.setAttribute("aria-label", playing ? (c.getAttribute("data-label-pause") || "Pause film") : (c.getAttribute("data-label-play") || "Play film"));
    });
  };
  var gestureArmed = false;
  var armGesture = function () {
    if (gestureArmed) return;
    gestureArmed = true;
    var evs = ["touchstart", "touchend", "pointerdown", "pointerup", "click", "keydown", "scroll", "wheel"];
    var go = function () {
      evs.forEach(function (ev) { window.removeEventListener(ev, go, true); });
      gestureArmed = false;
      vids.forEach(function (v) { if (visible.get(v) && v.paused) tryPlay(v, 2); });
    };
    evs.forEach(function (ev) { window.addEventListener(ev, go, { capture: true, passive: true }); });
  };
  var tryPlay = function (v, attempt) {
    var k = keyOf(v);
    if (userPaused[k] || !rendered(v)) return;
    if ((reduced.matches || lowData) && !userStarted[k]) return;
    load(v);
    var p = v.play();
    if (p && p.catch) p.catch(function (e) {
      paint(k);
      /* Autoplay refused (some WebKit builds, iOS Low Power Mode): the poster and Play button stay,
         and every visible film starts on the visitor's first touch, scroll or key press */
      if (e && e.name === "NotAllowedError") {
        attempt = attempt || 0;
        if (attempt < 2) setTimeout(function () { if (visible.get(v) !== false && v.paused) tryPlay(v, attempt + 1); }, 700);
        armGesture();
      }
    });
  };
  vids.forEach(function (v) {
    if (phone.matches && v.getAttribute("data-poster-m")) v.poster = v.getAttribute("data-poster-m");
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute("muted", ""); v.setAttribute("playsinline", "");
    var k = keyOf(v);
    ["playing", "pause", "error", "ended"].forEach(function (ev) { v.addEventListener(ev, function () { paint(k); }); });
    v.addEventListener("playing", function () { var f = v.closest(".film"); if (f) f.classList.add("is-live"); });
    paint(k);
  });
  doc.querySelectorAll("[data-film-ctl]").forEach(function (c) {
    c.addEventListener("click", function () {
      var k = c.getAttribute("data-group") || keyOf(c.closest(".film").querySelector("video"));
      var mine = vids.filter(function (v) { return keyOf(v) === k && rendered(v); });
      var playing = mine.some(function (v) { return !v.paused; });
      if (playing) {
        userPaused[k] = true;
        mine.forEach(function (v) { v.pause(); });
      } else {
        userPaused[k] = false; userStarted[k] = true;
        mine.forEach(function (v) {
          if (v.error) { v.removeAttribute("data-loaded"); }
          load(v);
          var p = v.play(); if (p && p.catch) p.catch(function () { paint(k); });
        });
      }
      paint(k);
    });
  });
  if (hasIO) {
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !reduced.matches && !lowData) { load(e.target); near.unobserve(e.target); } });
    }, { rootMargin: "300px 0px" });
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible.set(e.target, e.isIntersecting);
        if (e.isIntersecting) tryPlay(e.target); else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { near.observe(v); vio.observe(v); });
  } else { vids.forEach(tryPlay); }
  doc.addEventListener("visibilitychange", function () {
    vids.forEach(function (v) {
      if (doc.hidden) { if (!v.paused) v.pause(); }
      else if (visible.get(v)) tryPlay(v);
    });
  });
  var onReduce = function () {
    vids.forEach(function (v) { var k = keyOf(v); if (reduced.matches && !userStarted[k]) v.pause(); else if (visible.get(v)) tryPlay(v); });
  };
  if (reduced.addEventListener) reduced.addEventListener("change", onReduce);
})();
